import { canvasLabelMeasurer } from '@ardoq/graph-labeling';
import { fontFamily } from '@ardoq/design-tokens';
import {
  AGGREGATED_COUNT_LABEL_FONT_WEIGHT,
  AGGREGATED_COUNT_LABEL_PADDING,
  AGGREGATED_COUNT_LABEL_SIZE,
} from '../consts';

const COUNT_LABEL_FONT = `${AGGREGATED_COUNT_LABEL_FONT_WEIGHT} ${AGGREGATED_COUNT_LABEL_SIZE}px/normal ${fontFamily.regular}`;
const measureCountLabelText = canvasLabelMeasurer(COUNT_LABEL_FONT);
const measureLabel = (text: string) =>
  measureCountLabelText(text) + AGGREGATED_COUNT_LABEL_PADDING * 2;

const getEstimateCountLabelWidth = (measureLabel: (text: string) => number) => {
  /** cache for widths for frequent digits numbers */
  const digitCountMap = new Map(
    ['9', '99'].map(num => [num.length, measureLabel(num)])
  );
  return (count: number) => {
    const digitsCount = `${count}`.length;

    const countLabelWidth = digitCountMap.get(digitsCount);

    if (countLabelWidth) {
      return countLabelWidth;
    }
    const newLabelMeasure = measureLabel('9'.repeat(digitsCount));

    digitCountMap.set(digitsCount, newLabelMeasure);

    return newLabelMeasure;
  };
};

const estimateCountLabelWidth = getEstimateCountLabelWidth(measureLabel);
export { estimateCountLabelWidth };
